// import React from "react";
// import { useEffect } from "react";
// import { useState } from "react";
// import MobileHeader from "../../components/header/MobileHeader";
// import LoginHeader from "../../components/header/LoginHeader";
// import Footer from "../../components/footer";
// import Gotop from "../../components/gotop";
// import BulkResume from "./BulkResume";
// import LoginMobileHeader from "../../components/header/LoginMobileHeader";
// import InstituteHeader from "../../components/header/InstituteHeader";
// import InstituteMobileHeader from "../../components/header/InstituteMobileHeader";
// import { Helmet } from "react-helmet";
// import InstituteAssignedTest from "./InstituteAssignedTest";

// ManageInterview.propTypes = {};

// function ManageInterview(props) {
//     const [isShowMobile, setShowMobile] = useState(false);

//     const handleMobile = () => {
//         const getMobile = document.querySelector(".menu-mobile-popup");
//         setShowMobile(!isShowMobile);
//         !isShowMobile
//             ? getMobile.classList.add("modal-menu--open")
//             : getMobile.classList.remove("modal-menu--open");
//     };

//     useEffect(() => {
//         const WOW = require("wowjs");
//         window.wow = new WOW.WOW({
//             live: false,
//         });
//         window.wow.init();
//     }, []);

//     return (
//         <>
//             <Helmet>
//                 <title>/Institute/Candidate/ManageInterview | Jobkikhoj</title>
//                 <meta name="description" content=" " />
//                 <meta name="keywords" content=" " />
//                 <meta property="og:title" content=" /Institute/Candidate/ManageInterview | Jobkikhoj" />
//                 <meta property="og:description" content="" />
//                 <meta property="og:url" content="https://jobkikhoj.com" />
//             </Helmet>
//             <InstituteMobileHeader handleMobile={handleMobile} />
//             <InstituteHeader clname="manageBatch" handleMobile={handleMobile} />
//             {/* <LoginHeader clname="act1" handleMobile={handleMobile} /> */}
//             <div className="pt-70">
//                 <InstituteAssignedTest />
//                 <Footer />
//                 <Gotop />
//             </div>
//         </>
//     );
// }

// export default ManageInterview;


import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import MobileHeader from "../../components/header/MobileHeader";
import LoginHeader from "../../components/header/LoginHeader";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import Breadcrumb from "../../components/breadcrumb";
// import EditCard from "./EditCard";
import LoginMobileHeader from "../../components/header/LoginMobileHeader";
import InstituteMobileHeader from "../../components/header/InstituteMobileHeader";
import CRMobileHeader from "../../components/header/CRMobileHeader";
import InstituteHeader from "../../components/header/InstituteHeader";
import CRHeader from "../../components/header/CRHeader";
import NonLoginHeader from "../../components/header/NonLoginHeader";
import { Helmet } from "react-helmet";
import InstituteAssignedTest from "./InstituteAssignedTest";

ManageInterview.propTypes = {};

function ManageInterview(props) {

    const [isShowMobile, setShowMobile] = useState(false);

    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };

    useEffect(() => {
        const WOW = require("wowjs");
        window.wow = new WOW.WOW({
            live: false,
        });
        window.wow.init();
    }, []);
    const module = localStorage.getItem('Module')
    return (
        <>
            <Helmet>
                <title>Manage Test | Jobkikhoj</title>
                <meta name="description" content=" " />
                <meta name="keywords" content=" " />
                <meta property="og:title" content="Manage Test | Jobkikhoj " />
                <meta property="og:description" content="" />
                <meta property="og:url" content="https://jobkikhoj.com" />
            </Helmet>
            {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
                            <MobileHeader handleMobile={handleMobile} />}
            {module === 'Candidate' ? <LoginHeader clname="manageBatch" handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteHeader clname="manageBatch" handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRHeader clname="manageBatch" handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRHeader clname="manageBatch" handleMobile={handleMobile} /> :
                            <NonLoginHeader clname="manageBatch" handleMobile={handleMobile} />}

            <div className="pt-70">
                <InstituteAssignedTest/>
                <Footer />
                <Gotop />
            </div>
        </>
    );
}

export default ManageInterview;
